import type { AgencyPriceRange } from '@saaga/shared/interfaces/agencies.interface'
import { DollarSignIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface PriceRangeIndicatorProps {
  level: AgencyPriceRange
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeClassMap: Record<NonNullable<PriceRangeIndicatorProps['size']>, string> = {
  sm: 'size-3',
  md: 'size-4',
  lg: 'size-5',
}

const PRICE_LEVEL_KEY_LIST = ['price-1', 'price-2', 'price-3']

export const PriceRangeIndicator = ({
  level,
  size = 'md',
  className,
}: PriceRangeIndicatorProps): ReactNode => {
  const sizeClass = sizeClassMap[size]

  return (
    <div className={cn('price-range-indicator flex items-center', className)}>
      {PRICE_LEVEL_KEY_LIST.map((key, index) => {
        const isActive = index < level
        return (
          <DollarSignIcon
            key={key}
            className={cn(
              sizeClass,
              '-mx-0.5',
              isActive ? 'text-emerald-600 dark:text-emerald-400' : 'text-muted-foreground/30'
            )}
          />
        )
      })}
    </div>
  )
}
